// локальный мини-компонент
//
export function BtnSpinner({ size = 16, stroke = 2 }: { size?: number; stroke?: number }) {
    return (
        <span
            aria-hidden
            style={{
                display: 'inline-block',
                width: size,
                height: size,
                border: `${stroke}px solid rgba(255,255,255,.4)`,
                borderTopColor: '#fff',
                borderRadius: '50%',
                animation: 'btnspin .8s linear infinite',
                verticalAlign: 'middle',
                marginRight: 8
            }}
        />
    );
}
